import { styled, TextField, Chip } from '@mui/material'

export const StyledInputField = styled(TextField)(({ theme }) => ({
  display: 'inline-flex',
  width: '100%',
  position: 'absolute',
  left: 0,
  top: 0,
  zIndex: 2,
  '& .MuiInputBase-input': {
    paddingRight: theme.spacing(4),
  },
  '& .MuiInputBase-root': {
    paddingTop: 0,
    minHeight: 52,
  },
  '&.heightLevelOne': {
    '& > div': {
      height: '95px',
    },
  },
  '&.heightLevelTwo': {
    '& > div': {
      height: '140px',
    },
  },
  '&.heightLevelThree': {
    '& > div': {
      height: '174px',
    },
  },
  '&.heightLevelFour': {
    '& > div': {
      height: '210px',
    },
  },
}))

export const StyledChip = styled(Chip)(({ theme }) => ({
  '& .MuiChip-label': {
    width: '100%',
  },
  '& .MuiChip-deleteIcon': {
    width: '12px',
    zIndex: 6,
  },
  '& svg > path': {
    d:
      'path("M9.66732 1.27301L8.72732 0.333008L5.00065 4.05967L1.27398 0.333008L0.333984 1.27301L4.06065 4.99967L0.333984 8.72634L1.27398 9.66634L5.00065 5.93967L8.72732 9.66634L9.66732 8.72634L5.94065 4.99967L9.66732 1.27301Z")',
    fill: 'black',
    fillOpacity: 0.4,
  },
  position: 'relative',
  borderRadius: '4px',
  backgroundColor: '#F0F0F0',
  margin: '3px',
  maxWidth: 'calc(100% - 40px)',
  zIndex: 3,
  [theme.breakpoints.down('xs')]: {
    maxWidth: theme.spacing(21.5),
  },
}))
